import { render, staticRenderFns } from "./template/up-coming-events/index.html?vue&type=template&id=34d4e57c&scoped=true&external"
import script from "./UpComingEvents.vue?vue&type=script&lang=js"
export * from "./UpComingEvents.vue?vue&type=script&lang=js"
import style0 from "./UpComingEvents.vue?vue&type=style&index=0&id=34d4e57c&prod&lang=scss&scoped=true"
import style1 from "./UpComingEvents.vue?vue&type=style&index=1&id=34d4e57c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d4e57c",
  null
  
)

export default component.exports